import { render, staticRenderFns } from "./PSDArtboardsPreview.vue?vue&type=template&id=50ef3b1a&scoped=true"
import script from "./PSDArtboardsPreview.vue?vue&type=script&lang=js"
export * from "./PSDArtboardsPreview.vue?vue&type=script&lang=js"
import style0 from "./PSDArtboardsPreview.vue?vue&type=style&index=0&id=50ef3b1a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ef3b1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50ef3b1a')) {
      api.createRecord('50ef3b1a', component.options)
    } else {
      api.reload('50ef3b1a', component.options)
    }
    module.hot.accept("./PSDArtboardsPreview.vue?vue&type=template&id=50ef3b1a&scoped=true", function () {
      api.rerender('50ef3b1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/psd-layers/PSDArtboardsPreview.vue"
export default component.exports